import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id E82C7336-9ECE-4BA9-84BA-AA229FBF4E37
 * name alpha-z
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-z.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaZIcon = createSvgIcon(<><path d="M9,7V9H13L9,15V17H15V15H11L15,9V7H9Z" /></>, 'AlphaZIcon');
export default AlphaZIcon